type Props = {
  label: string
  value: string
}

export function Fact({ label, value }: Props) {
  return (
    <div>
      <p className="font-mono text-[9px] text-white/35 uppercase tracking-[0.35em]">
        {label}
      </p>
      <p className="mt-1 font-mono text-[13px] text-foreground uppercase tracking-[0.04em]">
        {value}
      </p>
    </div>
  )
}
